import axios from "axios"
import qs from 'query-string'
import { googleSdkLoaded } from "vue3-google-login"
import store from '../../store'
import { emails_set_pagination } from "../../store/modules/emails/actions"
import * as mutations from '../../store/mutation-types'
import { Mime } from './mime'
import { Base64 } from "./mime/base64"
import { get_file_extension, md5_from_base64, split_emails } from './utils'

let token = localStorage.getItem("GMAIL_SESSION")

const people_api_axios_instance = axios.create({
    baseURL: 'https://people.googleapis.com/v1/',
    timeout: 1000,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
    }
});

const UrlGmail = 'https://gmail.googleapis.com/gmail/v1'

export async function autocomplete_contacts(query, params_ = {}) {
    // const token = (gapi.client.getToken() || {}).access_token
    if (!token) {
        return Promise.reject()
    }
    const params = {
        pageSize: 2,
        query,
        readMask: 'emailAddresses,names,photos',
        sources: "DIRECTORY_SOURCE_TYPE_DOMAIN_PROFILE,DIRECTORY_SOURCE_TYPE_DOMAIN_CONTACT,DIRECTORY_SOURCE_TYPE_UNSPECIFIED",
        ...params_,
    }
    const response = await axios.request({
        method: 'get',
        maxBodyLength: Infinity,
        url: `https://people.googleapis.com/v1/people:searchDirectoryPeople?readMask=${params.readMask}&query=${params.query}&sources=${params.sources}&pageSize=${params.pageSize}`,
        headers: {
            'Authorization': token
        }
    })

    console.log(response)


    if (response.data.results) {
        return response.data.results.map(result => {
            const { person: { emailAddresses, names, photos, } } = result
            return {
                email: emailAddresses[0].value,
                first_name: names[0].givenName,
                last_name: names[0].familyName || '',
                name: names[0].displayName,
                photoUrl: photos[0].url,
                type: 'contact',
            }
        })
    }
    return []
}

export async function autocomplete_ordino_contacts(search_term, params_ = {}) {
    const params = {
        limit: 2,
        search_term,
        ...params_,
    }
    const response = await axios.get(`/api/contacts`, { params })
    if (!response) {
        return []
    }
    const response2 = await axios.get(`/api/users`, { params })
    if (!response2) {
        return []
    }

    return [...response.data.data, ...response2.data.data].map(result => result)

}

export async function fetchMessage(message_id) {
    return get_thread(message_id, true)
}

export async function fetchMessageGmailIndividual(message_id) {
    return get_message_individual(message_id, true)
}

export async function fetchMessageByData(data) {
    return get_messages_from_data({ result: data }, true)
}

export async function fetchMessages(params) {
    if (params.pageToken) {
        const response = await axios.request({
            method: 'get',
            maxBodyLength: Infinity,
            url: `${UrlGmail}/users/me/threads?includeSpamTrash=${params.includeSpamTrash}&labelIds=${params.labelIds[0]}&maxResults=${params.maxResults}&pageToken=${params.pageToken}`,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(token).access_token
            }
        }),
            { threads: messages = [], nextPageToken } = response.data

        // emails_set_pagination(store, { total: response.data.resultSizeEstimate, page: 1, perPage: params.maxResults, pageCount: Math.ceil(response.data.resultSizeEstimate / params.maxResults) })


        return { messages, nextPageToken, response }

    }
    if (params.q) {
        const response = await axios.request({
            method: 'get',
            maxBodyLength: Infinity,
            url: `${UrlGmail}/users/me/threads?includeSpamTrash=${params.includeSpamTrash}&labelIds=${params.labelIds[0]}&maxResults=${params.maxResults}&q=${params.q}`,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(token).access_token
            }
        }),
            { threads: messages = [], nextPageToken } = response.data

        let pagination = {
            total: response.data.resultSizeEstimate,
            page: 1,
            perPage: params.maxResults,
            pageCount: Math.ceil(response.data.resultSizeEstimate / params.maxResults),
            navigationObject: {
                initial: {
                    next: nextPageToken,
                    previous: null
                }
            }
        }

        emails_set_pagination(store, pagination)

        return { messages, nextPageToken, response }
    }
    else {
        const response = await axios.request({
            method: 'get',
            maxBodyLength: Infinity,
            url: `${UrlGmail}/users/me/threads?includeSpamTrash=${params.includeSpamTrash}&labelIds=${params.labelIds[0]}&maxResults=${params.maxResults}`,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(token).access_token
            }
        }),
            { threads: messages = [], nextPageToken } = response.data


        return { messages, nextPageToken, response }
    }


}

export async function fetchEmailByThreadId(id) {

    return await axios.request({
        method: 'get',
        maxBodyLength: Infinity,
        url: `${UrlGmail}/users/me/threads/${id}`,
        headers: {
            "Authorization": "Bearer " + JSON.parse(token).access_token
        }
    })
}

export async function get_message_attachment(file) {
    const { id, message_id: messageId } = file, gapi = store.getters.emails_gapi, params = { id, messageId, userId: 'me' }
        , decode = function (input) {
            // Replace non-url compatible chars with base64 standard chars
            input = input
                .replace(/-/g, '+')
                .replace(/_/g, '/');
            // Pad out with standard base64 required padding characters
            let pad = input.length % 4;
            if (pad) {
                if (pad === 1) {
                    throw new Error('InvalidLengthError: Input base64url string is the wrong length to determine padding');
                }
                input += new Array(5 - pad).join('=');
            }
            return input;
        }
    let response = ''
    try {
        // response = await gapi.client.gmail.users.messages.attachments.get(params)
        response = await axios.request({
            method: "GET",
            maxBodyLength: Infinity,
            url: `${UrlGmail}/users/${params.userId}/messages/${params.messageId}/attachments/${params.id}`,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(token).access_token
            }
        })
        response.data.data = decode(response.data.data)
        // console.log(response.result)
        return response.data
    } catch (error) {
        console.log('error', error)
    }
    return Promise.reject()
}

export function fetch_file(file, only_base64 = false) {
    // console.log(file)
    if (!file.path) {
        return new Promise((resolve, reject) => {
            file.loading = true
            get_message_attachment(file).then(res => {
                file.base64 = res.data
                file.data = res.data
                file.type = file.mimeType
                if (file.mimeType === 'undefined') {
                    const ext = get_file_extension(file.filename)
                    if (ext === 'pdf') {
                        file.mimeType = file.type = 'application/pdf'
                    }
                }
                file.data_url = `data:${file.type};base64,${res.data}`
                file.hash_md5 = md5_from_base64(file.data)
                if (only_base64) {
                    file.loading = false
                    resolve(file)
                    return
                }
                fetch(file.data_url)
                    .then(res => res.blob())
                    .then(blob => {
                        file.path = URL.createObjectURL(blob)
                        file.loading = false
                        resolve(file)
                    }, reject)
            })
        })
    }
    if (!file.base64) {
        return new Promise((resolve, reject) => {
            file.loading = true
            const fileReader = new FileReader();
            fileReader.onload = () => {
                file.data_url = fileReader.result
                file.base64 = fileReader.result.replace(new RegExp(`^data:[^/]+/[^;]+;base64,`), '')
                file.hash_md5 = md5_from_base64(file.base64)
                file.loading = false
                resolve(file)
            }
            fetch(file.path).then(res => res.blob()).then(blob => fileReader.readAsDataURL(blob)).catch(reject).then(() => {
                file.loading = false
            })
        })
    }
    return Promise.resolve(file)
}

export function fetch_files(files = [], only_base64 = false) {
    const promises = []
    files.forEach(file => promises.push(fetch_file(file, only_base64)))
    if (promises.length) {
        return Promise.allSettled(promises)
    }
    return Promise.resolve()
}

export function fetch_message_files(message) {
    if (!message.files) {
        message.files = get_message_files(message)
    }
    return fetch_files(message.files)
}

export function initialize($gapi) {
    return $gapi.getGapiClient()
}

export function get_compose_message(message, type = 'reply') {
    let payload = message.payload
    payload = typeof payload === 'string' ? JSON.parse(payload) : payload
    const compose_message = {
        attaches: [],
        bcc: [],
        body: '',
        cc: [],
        source_message: null,
        subject: '',
        from: store.getters.emails_get_profile.email,
        to: [],
    }
    const user_email = store.getters.emails_get_profile.email,
        headers = payload.headers,
        subject = get_header(headers, 'Subject'),
        from = get_header(headers, 'From'),
        to = get_header(headers, 'To'),
        cc = get_header(headers, 'Cc'),
        message_id = get_header(headers, 'Message-ID')
    compose_message.source_message = message
    compose_message.subject = subject
    switch (type) {
        case 'forward':
            compose_message.is_forward = true
            compose_message.is_reply = false
            compose_message.subject = `Fwd: ${subject}`
            const add_attachment = file => compose_message.attaches.push(file)
            fetch_message_files(message).then(() => message.files.forEach(add_attachment))
            break
        case 'reply':
            compose_message.is_forward = false
            compose_message.is_reply = true
            compose_message.in_reply_to = message_id
            compose_message.references = message_id
            compose_message.to = [split_emails(from)[0].trim()]
            break
        case 'replyAll':
            compose_message.is_forward = false
            compose_message.is_reply = true
            compose_message.in_reply_to = message_id
            compose_message.references = message_id
            compose_message.to = [...split_emails(from), ...split_emails(to).filter(i => i.indexOf(user_email) === -1)]
            if (cc) {
                compose_message.cc = [...split_emails(cc).filter(i => i.indexOf(user_email) === -1)]
            }
            break
        default:
            break
    }
    return compose_message
}

export async function getLabelInfo(label = 'INBOX') {
    // const gapi = store.getters.emails_gapi
    // if (!gapi) {
    //     return Promise.reject()
    // }

    return await axios.request({
        method: 'get',
        maxBodyLength: Infinity,
        url: `${UrlGmail}/users/me/labels/${label}`,
        headers: {
            'Authorization': 'Bearer ' + JSON.parse(token).access_token
        }
    })
}


export async function get_signature() {
    const gapi = store.getters.emails_gapi
    let response = ''
    try {
        response = await axios.request({
            method: 'get',
            maxBodyLength: Infinity,
            url: `${UrlGmail}/users/me/settings/sendAs`,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(token).access_token
            }
        })
        return response.data.sendAs[0].signature
    } catch (error) {
    }
    return ''
}

export async function get_thread(id, full) {

    let data = await axios.request({
        method: 'get',
        maxBodyLength: Infinity,
        url: `${UrlGmail}/users/me/threads/${id}`,
        headers: {
            'Authorization': 'Bearer ' + JSON.parse(token).access_token
        }
    })


    return get_messages_from_data(data, full)
}

export async function get_message_individual(id, full) {
    const response = await axios.request({
        method: 'get',
        maxBodyLength: Infinity,
        url: `${UrlGmail}/users/me/messages/${id}`,
        headers: {
            'Authorization': 'Bearer ' + JSON.parse(token).access_token
        }
    })

    return get_messages_from_data(response, full)
}

export async function get_thread_summary(id) {
    const response = await axios.request({
        method: 'get',
        maxBodyLength: Infinity,
        url: `${UrlGmail}/users/me/threads/${id}`,
        headers: {
            'Authorization': 'Bearer ' + JSON.parse(token).access_token
        }
    })
    return get_message_from_response(response)
}

export async function listLabels() {
    // const gapi = store.getters.emails_gapi
    // return gapi.client.gmail.users.labels
    //     .list({
    //         userId: "me",
    //     })
    //     .then((response) => response.result.labels)

    return axios.request({
        method: 'get',
        maxBodyLength: Infinity,
        url: 'https://gmail.googleapis.com/gmail/v1/users/me/labels',
        headers: {
            'Authorization': 'Bearer ' + JSON.parse(token).access_token
        }
    }).then((response) => response.data.labels)
}

export async function mark_as(message_id, read = true, thread = true) {
    const gapi = store.getters.emails_gapi
    const params = {
        id: message_id,
        userId: 'me',
    }
    const type = thread ? 'threads' : 'messages'
    if (read) {
        params.removeLabelIds = ["UNREAD"]
    } else {
        params.addLabelIds = ["UNREAD"]
    }
    // const response = await gapi.client.gmail.users[type].modify(params)
    const response = await axios.request({
        method: 'post',
        maxBodyLength: Infinity,
        url: params.addLabelIds ? `${UrlGmail}/users/me/${[type]}/${params.id}/modify?addLabelIds=${params.addLabelIds}` : `${UrlGmail}/users/me/${[type]}/${params.id}/modify?removeLabelIds=${params.removeLabelIds}`,
        headers: {
            'Authorization': 'Bearer ' + JSON.parse(token).access_token
        }
    })
    const { data: { messages = [] } } = response
    if (messages.length && store.getters.emails_get_messages.length) {
        const store_messages = [...store.getters.emails_get_messages]
        const message = messages.find(m => m.id === message_id || m.threadId === message_id)
        const m = store_messages.find(m => m.message_id === message_id)
        if (!!message && !!m && Array.isArray(message.labelIds)) {
            m.label_ids = [...message.labelIds]
            thread && Array.isArray(m.messages) && m.messages.forEach(m => {
                (message.id === m.message_id) && (!read && !m.label_ids.includes('UNREAD') && m.label_ids.push('UNREAD') || read && (m.label_ids = m.label_ids.filter(label => label !== 'UNREAD')))
            })
        }
        store.commit(mutations.EMAILS_SET_MESSAGES, store_messages)
    }
    return response
}

export async function mark_message_as_read(message_id) {
    return await mark_as(message_id, true, false)
}

export async function mark_message_as_unread(message_id) {
    return await mark_as(message_id, false, false)
}

export async function mark_thread_as_read(message_id) {
    return await mark_as(message_id, true, true)
}

export async function mark_threads_as_read(threads_ids) {
    const promises = []
    threads_ids.forEach(message_id => promises.push(mark_thread_as_read(message_id)))
    return Promise.allSettled(promises)
}

export async function mark_thread_as_unread(message_id) {
    return await mark_as(message_id, false, true)
}

export async function mark_threads_as_unread(threads_ids) {
    const promises = []
    threads_ids.forEach(message_id => promises.push(mark_thread_as_unread(message_id)))
    return Promise.allSettled(promises)
}

export async function send_email(email, draft) {

    if (!!draft) {

        let message = `From: ${email.from}\nTo: ${email.to}\nSubject: ${email.subject}\nMIME-Version: 1.0\nContent-Type: text/html; charset="UTF-8"\n\n${email.body}`;

        if (email.cc !== '') {
            message = `From: ${email.from}\nTo: ${email.to}\nCc: ${email.cc}\nSubject: ${email.subject}\nMIME-Version: 1.0\nContent-Type: text/html; charset="UTF-8"\n\n${email.body}`;
        }

        if (email.bcc !== '') {
            message = `From: ${email.from}\nTo: ${email.to}\nBcc: ${email.bcc}\nSubject: ${email.subject}\nMIME-Version: 1.0\nContent-Type: text/html; charset="UTF-8"\n\n${email.body}`;
        }

        if (email.cc !== '' && email.bcc !== '') {
            message = `From: ${email.from}\nTo: ${email.to}\nCc: ${email.cc}\nBcc: ${email.bcc}\nSubject: ${email.subject}\nMIME-Version: 1.0\nContent-Type: text/html; charset="UTF-8"\n\n${email.body}`;
        }

        const raw = btoa(message);

        return await axios.request({
            method: 'post',
            maxBodyLength: Infinity,
            url: `${UrlGmail}/users/me/drafts`,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(token).access_token
            },
            data: raw
        })
    }

    if (email.is_reply) {
        // return await axios.request({
        //     method: 'post',
        //     maxBodyLength: Infinity,
        //     url: `${UrlGmail}/users/me/messages/send`,
        //     headers: {
        //         'Authorization': 'Bearer ' + JSON.parse(token).access_token,
        //         'Content-Type': 'application/json',
        //     },
        //     data: {
        //         raw: btoa(`From: ${email.source_message.to}\nTo: ${email.to}\nSubject: ${email.subject}\n\n${email.body}!`),
        //         threadId: email.source_message.thread_id
        //     }
        // })
    }

    if (email.attaches.length > 0) {

        let to = email.to
        let from = email.from
        let subject = email.subject
        let body = email.body
        let cc = email.cc
        let bcc = email.bcc


        let message =
            `Content-Type: multipart/mixed; boundary=foo_bar_baz\nMIME-Version: 1.0\nto: ${to}\nfrom: ${from}\nsubject: ${subject}\n\n--foo_bar_baz\nContent-Type: text/html; charset="UTF-8"\n
${body}\n\n--foo_bar_baz${email.attaches.map(attach => {
                return `\nContent-Type: ${attach.type}\nMIME-Version: 1.0\nContent-Transfer-Encoding: base64\nContent-Disposition: attachment; filename="${attach.name}"

                ${attach.base64}
                `
            }
            )
            }\n-foo_bar_baz-`;

        if (cc !== '') {
            message = `Content-Type: multipart/mixed; boundary=foo_bar_baz\nMIME-Version: 1.0\nto: ${to}\nfrom: ${from}\ncc: ${cc}\nsubject: ${subject}\n\n--foo_bar_baz\nContent-Type: text/html; charset="UTF-8"\n
${body}\n\n--foo_bar_baz${email.attaches.map(attach => {
                return `\nContent-Type: ${attach.type}\nMIME-Version: 1.0\nContent-Transfer-Encoding: base64\nContent-Disposition: attachment; filename="${attach.name}"

                ${attach.base64}
                `
            }
            )
                }\n-foo_bar_baz-`;
        }

        if (bcc !== '') {
            message = `Content-Type: multipart/mixed; boundary=foo_bar_baz\nMIME-Version: 1.0\nto: ${to}\nfrom: ${from}\nbcc: ${bcc}\nsubject: ${subject}\n\n--foo_bar_baz\nContent-Type: text/html; charset="UTF-8"\n
${body}\n\n--foo_bar_baz${email.attaches.map(attach => {
                return `\nContent-Type: ${attach.type}\nMIME-Version: 1.0\nContent-Transfer-Encoding: base64\nContent-Disposition: attachment; filename="${attach.name}"

                ${attach.base64}
                `
            }
            )
                }\n-foo_bar_baz-`;

        }

        if (cc !== '' && bcc !== '') {
            message = `Content-Type: multipart/mixed; boundary=foo_bar_baz\nMIME-Version: 1.0\nto: ${to}\nfrom: ${from}\ncc: ${cc}\nbcc: ${bcc}\nsubject: ${subject}\n\n--foo_bar_baz\nContent-Type: text/html; charset="UTF-8"\n
${body}\n\n--foo_bar_baz${email.attaches.map(attach => {
                return `\nContent-Type: ${attach.type}\nMIME-Version: 1.0\nContent-Transfer-Encoding: base64\nContent-Disposition: attachment; filename="${attach.name}"

                ${attach.base64}
                `
            }
            )
                }\n-foo_bar_baz-`;
        }

        const raw = btoa(message);


        return await axios.request({
            method: 'post',
            maxBodyLength: Infinity,
            url: `${UrlGmail}/users/me/messages/send`,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(token).access_token,
                'Content-Type': 'message/rfc822'
            },
            data: {
                'raw': raw
            }
        })
    }

    let message = `From: ${email.from}\nTo: ${email.to}\nSubject: ${email.subject}\nMIME-Version: 1.0\nContent-Type: text/html; charset="UTF-8"\n\n${email.body}`;

    if (email.cc !== '' && email.bcc !== '') {
        message = `From: ${email.from}\nTo: ${email.to}\nCc: ${email.cc}\nBcc: ${email.bcc}\nSubject: ${email.subject}\nMIME-Version: 1.0\nContent-Type: text/html; charset="UTF-8"\n\n${email.body}`;
    }

    if (email.cc !== '') {
        message = `From: ${email.from}\nTo: ${email.to}\nCc: ${email.cc}\nSubject: ${email.subject}\nMIME-Version: 1.0\nContent-Type: text/html; charset="UTF-8"\n\n${email.body}`;
    }

    if (email.bcc !== '') {
        message = `From: ${email.from}\nTo: ${email.to}\nBcc: ${email.bcc}\nSubject: ${email.subject}\nMIME-Version: 1.0\nContent-Type: text/html; charset="UTF-8"\n\n${email.body}`;
    }

    const raw = btoa(message);

    return await axios.request({
        method: 'post',
        maxBodyLength: Infinity,
        url: `${UrlGmail}/users/me/messages/send`,
        headers: {
            'Authorization': 'Bearer ' + JSON.parse(token).access_token,
            'Content-Type': 'application/json'
        },
        data: {
            'raw': raw
        }
    })
}

export async function send_scheduled(email, date) {
    const mimeData = Mime.toMimeTxt(email), raw = window.btoa(unescape(encodeURIComponent(mimeData)))
        , draft_message_response = await axios.request({
            method: 'post',
            maxBodyLength: Infinity,
            url: `${UrlGmail}/users/me/messages/send`,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(token).access_token
            },
            data: raw
        })
    if (!draft_message_response.data || !draft_message_response.data.id) {
        return Promise.reject()
    }
    const message_id = draft_message_response.data.id
        , data = {
            message_id,
            date,
        },
        response = await axios.post(`/api/emails/sendScheduled`, data)
    if (response && response.data) {
        return
    }
    return Promise.reject()
}

export async function send_to_trash(message_id, thread = true, trash = true) {
    const gapi = store.getters.emails_gapi,
        params = {
            id: message_id,
            userId: 'me',
        },
        method = trash ? 'trash' : 'untrash',
        type = thread ? 'threads' : 'messages',
        response = await gapi.client.gmail.users[type][method](params)
    if (store.getters.emails_get_messages.length && trash) {
        const store_messages = [...store.getters.emails_get_messages].filter(m => m.message_id !== message_id)
        store.commit(mutations.EMAILS_SET_MESSAGES, store_messages)
    }
    return { message_id, response }
}

export async function trash_message(message_id) {
    return send_to_trash(message_id, false)
}

export async function trash_thread(thread_id) {
    return send_to_trash(thread_id, true)
}

export async function trash_threads(threads_ids) {
    const promises = []
    threads_ids.forEach(message_id => promises.push(trash_thread(message_id)))
    return Promise.allSettled(promises)
}

export async function untrash_message(message_id) {
    return send_to_trash(message_id, false, false)
}

export async function untrash_thread(thread_id) {
    return send_to_trash(thread_id, true, false)
}

export async function untrash_threads(threads_ids) {
    const promises = []
    threads_ids.forEach(message_id => promises.push(untrash_thread(message_id)))
    return Promise.allSettled(promises)
}

export function get_message_files(message) {
    let { message_id, payload } = message, files = []
    payload = typeof payload === 'string' ? JSON.parse(payload) : payload
    let { parts: parts_ = [] } = payload
    parts_ = parts_ || []
    let parts = get_plain_parts(parts_)
    parts.forEach(p => {
        const file = {
            ...p,
            id: p.body.attachmentId,
            message_id,
            mime: p.mimeType,
            name: p.filename,
            size: p.body.size,
        }
        if (p.filename) {
            file.content_id = (get_header(p.headers, 'Content-ID') || '').replace(new RegExp('^<', 'g'), '').replace(new RegExp('>$', 'g'), '')
            let disposition = (get_header(p.headers, 'Content-Disposition') || '').split('; ')
            disposition = Array.isArray(disposition) && disposition.length && disposition[0] || disposition
            if (disposition) {
                file.disposition = disposition
            }
        }
        if (message.hasOwnProperty('user_id')) {
            file.user_id = message.user_id
        }
        !!p.filename && files.push(file)
    })
    return files
}

function get_plain_parts(parts_) {
    const parts = JSON.parse(JSON.stringify(parts_))
    let array = []
    parts.forEach(part => {
        const sub_parts = part.parts
        delete part.parts
        array.push(part)
        if (sub_parts) {
            array = [...array, ...get_plain_parts(sub_parts)]
        }
    })
    return array
}

export function get_names_and_email(from = '') {
    const array = (from || '').split(' ')
    return array.length > 1 && array.map(i => i.trim().replace(/^[<'"]+/g, '').replace(/[>'"]+$/g, '')).reduce((t, i, idx) => ((idx === (array.length - 1) && (t.push(i), t)) || (t.length > 0 && ((i.length > 0 && (t[0] += ' ' + i)), t)) || (t.length === 0 && [i])), []) || get_names_and_email(` ${from}`)
}

export function get_recipients_names({ cc = '', to = '' }) {
    return [cc, to].filter(i => !!i).reduce((total, i) => (split_emails(i).forEach(n => {
        const [name, email] = get_names_and_email(n)
        total.push(name.trim() || email)
    }), total), []).join(', ')
}

function get_date_from_message(message) {
    const { internalDate, payload } = message, headers = payload.headers,
        date = get_header(headers, 'Date') || (!!internalDate && parseInt(internalDate))
    return (!!date && moment(date).format('YYYY-MM-DD HH:mm:ss')) || date
}

function get_header(headers, name) {
    const header = headers.find(h => h.name === name)
    return !!header ? header.value : null
}

function base64Decode(input) {
    try {
        const buffer = Buffer.from(input, 'base64');
        return buffer.toString('utf-8');
    } catch (error) {
        console.error("Error decoding Base64:", error);
        return null;
    }
}


function get_message_body(message) {
    function getPart(parts, mime = 'text/html') {
        let body = null, bodyData = '', part = null, bodyParts = []
        do {
            part = parts.shift()
            if (!!part) {
                body = part.body
                bodyData = !!body && (mime === part.mimeType && `${bodyData}${base64Decode(body.data)}`) || bodyData
                if (part.parts) {
                    bodyData = `${bodyData}${getPart(part.parts, mime)}`
                }
            }
        } while (!!part);
        return bodyData
    }

    return function (message) {
        let bodyData = null, html, payload = message.payload
        payload = typeof payload === 'string' ? JSON.parse(payload) : payload
        const { body: { data }, mimeType, parts = [] } = payload
        html = getPart([...parts]) || getPart([...parts], 'text/plain') || ''
        bodyData = (mimeType === 'text/html' && !!data && Base64.decode(data)) || ''
        bodyData = `${bodyData}${html}`
        return (!!bodyData && bodyData) || message.snippet || ''
    }(message)
}

function get_message_from_response(response) {
    const { messages = [] } = get_messages_from_data(response) || {}
    let body = '', date = '', from = '', from_names_count = '', from_array = [], label_ids = [], subject
    const id = response.data.id
    if (messages.length) {
        const message = messages[0], { payload } = message, headers = payload.headers
        label_ids = message.labelIds
        let count = 0
        date = get_date_from_message(messages[messages.length - 1])
        subject = get_header(headers, 'Subject')
        const names_data = get_names_and_count(messages)
        count = names_data.count
        from_array = names_data.from_array
        count > 1 && (from_names_count = `${count}`)
        from_array.length && (from = from_array.map(i => i.name).join(', '))
        body = get_message_body(message)
    }
    return {
        body,
        date,
        from,
        from_array,
        from_names_count,
        label_ids,
        messages,
        message_id: id,
        subject,
        data: response.result
    }
}

export function get_names_and_count(messages) {
    const from_array = []
    let count = 0
    messages.forEach(m => {
        if (!!m.payload && Array.isArray(m.payload.headers)) {
            let f = get_header(m.payload.headers, 'From')
            let [name, f_email] = get_names_and_email(f)
            name = f_email === store.getters.emails_get_profile.emailAddress ? 'me' : (name || f_email)
            !from_array.some(i => {
                const included = i.name === name
                if (included) {
                    i.read = m.label_ids.includes('UNREAD') || i.read
                }
                return included
            }) && from_array.push({ name, read: m.label_ids.includes('UNREAD') })
            count++
        }
    })
    return { count, from_array }
}

function get_messages_from_data(response, full = false) {
    const { data: { messages = [] } } = response
    const messages_list = []
    let id, body = '', date = '', from = '', subject, to = '', cc = ''
    messages.forEach(message => {
        // console.log(message)
        const { labelIds: label_ids, payload, snippet, threadId: thread_id } = message, { headers } = payload
            , files = get_message_files(message)
        id = message.id
        date = get_date_from_message(message)
        subject = get_header(headers, 'Subject')
        from = get_header(headers, 'From')
        to = get_header(headers, 'To')
        cc = get_header(headers, 'Cc')
        body = get_message_body(message)
        if (!label_ids.includes('TRASH')) {
            messages_list.push({
                body,
                cc,
                date,
                files,
                from,
                label_ids,
                message_id: id,
                payload,
                snippet,
                subject,
                thread_id,
                to
            })
        }
    })
    return { messages: messages_list, data: response.data }
}

export async function check_auth() {
    // return axios.post(`/api/emails/checkAuth`)
    return await axios.request({
        method: 'get',
        maxBodyLength: Infinity,
        url: `${UrlGmail}/users/me/profile`,
        headers: {
            'Authorization': 'Bearer ' + JSON.parse(token).access_token
        }
    })
}

// export function login($gapi) {
//     return $gapi.login()
// }

export async function login() {
    await googleSdkLoaded(async (google) => {
        // google.accounts.id.initialize({
        //   client_id: window.Laravel.env.EMAILS.EMAILS_GMAIL_CLIENT_ID,
        //   ux_mode: "popup",
        //   callback: (response) => {
        //       console.log("Handle the response", typeof response.credential)
        //     let klk = this.decodeJwt(response.credential)
        //     console.log(klk, response)
        //     }
        // })
        // google.accounts.id.prompt();

        await google.accounts.oauth2.initTokenClient({
            client_id: window.Laravel.env.EMAILS.EMAILS_GMAIL_CLIENT_ID,
            scope: "https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/gmail.labels https://www.googleapis.com/auth/contacts https://www.googleapis.com/auth/contacts.readonly https://www.googleapis.com/auth/gmail.modify",
            callback: (response) => {
                window.localStorage.setItem("GMAIL_SESSION", JSON.stringify(response))
                setTimeout(() => window.location.reload(), 1000)
            }
        }).requestAccessToken()
    })
}

export function logout() {
    if (!!localStorage.getItem('GMAIL_SESSION')) {
        localStorage.removeItem('GMAIL_SESSION')
    }
    return this
}

export function server_login() {
    const {
        EMAILS_GMAIL_CLIENT_ID,
        EMAILS_GMAIL_SCOPES,
    } = window.Laravel.env.EMAILS,
        google_url = 'https://accounts.google.com/o/oauth2/auth',
        redirect_uri = `${window.location.origin}/webhook/gmail`,
        params = {
            access_type: 'offline',
            client_id: EMAILS_GMAIL_CLIENT_ID,
            prompt: 'select_account consent',
            redirect_uri,
            response_type: 'code',
            scope: EMAILS_GMAIL_SCOPES,
            state: '',
        },
        h = 560,
        w = 705,
        left = (screen.width / 2) - (w / 2),
        top = (screen.height / 2) - (h / 2),
        query_string = qs.stringify(params),
        url = `${google_url}?${query_string}`,
        auth_window = window.open(url, '_blank', `left=${left},location=yes,height=${h},top=${top},width=${w}`)
    return new Promise((resolve, reject) => {
        const interval = setInterval(() => {
            try {
                const { pathname } = auth_window.location
                if (pathname && pathname !== 'blank') {
                    clearInterval(interval)
                    auth_window.close()
                    const href = auth_window.location.href,
                        code_object = { ...qs.parse(href) },
                        code = Object.values(code_object)[0],
                        params = { code, redirect_uri }
                    axios.post(`/api/emails/authenticate`, params)
                        .then(res => {
                            const data = res.data
                            if (data) {
                                localStorage.setItem('GMAIL_SESSION', JSON.stringify(data))
                            }
                            return res
                        })

                    setTimeout(() => window.location.reload(), 1800)
                    resolve()
                }
            } catch (error) {
                console.log(error)
            }
        }, 200)
    }).then(auth_window.close)
}
